import cx from 'classnames2';
import React from 'react';

import styles from './InputTag.scss';

export interface ITagProps {
  tag?: any;
  onRemoveClick(tag): void;
}

export class Tag extends React.Component<ITagProps, any> {
  onRemoveClick = event => this.props.onRemoveClick(this.props.tag);

  public render() {
    const { tag } = this.props;

    return (
      <div className={cx('pt-tag', styles.tag)}>
        <span className={styles.tagText}>
          {tag.first_name} {tag.last_name}
        </span>
        <button className={styles.removeTag} onClick={this.onRemoveClick} />
      </div>
    );
  }
}
